<div>
  <gl-table
    [id]="keplerRankingGroupListId"
    [dataSource]="dataSource"
    data-testid="keplerRankingGroupTable"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    disableHeaderSelector
    (onDatasourceUpdate)="onDatasourceUpdate()"
  >
  </gl-table>
</div>
